import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import * as catActions from '../actions/brandActions';
import FeaturedBrandList from './featuredBrandList';
import { BrandAlphaCardList } from './brandAlphaCardList';

class BrandPage extends React.Component {

    //this function will group items into arrays (total items / numcols)
    putDataIntoRows(dataset, numcols) {
        let rows = [];
        for (var i = 0; i < dataset.length; i += numcols) {
            var row = [];
            row.push(dataset.slice(i, i + numcols));
            rows.push(row)
        }
        return rows;
    }

    render() {
        let numAllBrandCols = 3;
        let numTopBrandCols = 5;
        let groups = groupBrands(this.props.brands, numAllBrandCols);
        let topBrands = this.props.brands.filter(brand => brand.filterValueDisplayStyle === "Top");
        let topBrandsInRows = this.putDataIntoRows(topBrands, numTopBrandCols);

        return (
            <div>
                {topBrandsInRows.length > 0 && (<div className="top-brands-section">
                    <hr className="blue" />
                    <h3 className="dynamic-vertical-header">Choose From Featured Brands</h3>
                    {topBrandsInRows.map((row, index) => <FeaturedBrandList key={index} data={row} />)}
                </div>)}
                <div className="row">
                    <div className="col-md-12">
                        <hr className="blue" />
                        <h3 className="dynamic-vertical-header">Choose From All Brands</h3>
                    </div>
                </div>
                <div className="ink-toner row">
                    {groups.map((column, index) => <BrandAlphaCardList key={index} data={column} numCols={numAllBrandCols} />)}
                </div>
            </div>
        );
    }
}

/**
 * function to group brand listings by alpha-numeric keys
 * 
 * @param {array} brandArr brand manufactuers.
 * @param {integer} numOfCols number of columns data should be split into.
 * @returns {array} tableArr, array of column arrays
 */
function groupBrands(brandArr, numOfCols) {
    // Loop through the data and construct buckets for
    // all of the unique keys:
    var numElements = brandArr.length;
    var colElemMax = Math.floor(numElements / numOfCols) + 1;
    var groups = {};
    var tableArr = [];
    var colArr = [];
    var counter = 0;

    // build an associative array of unique alpha-numeric keys to group brands
    for (let i = 0; i < numElements; i++) {
        // grab first character of brand description
        var groupValue = brandArr[i].description.trim().charAt(0).toUpperCase();

        // check to see if we already have a group defined for this character, i.e. 'A'
        // if not create one, else add brand to the applicable group
        if (groups[groupValue] == undefined) {
            groups[groupValue] = new Array();
        }

        groups[groupValue].push(brandArr[i].description);
    }

    // repackage groups into basic array for desired column layout
    // react can only map arrays into components, not objects
    for (groupValue in groups) {

        // push groups onto a "column" array
        colArr.push(groups[groupValue]);

        // keep count of listings
        counter = counter + groups[groupValue].length;

        // check to see if we have passed element count break based on number of desired columns
        if (counter >= colElemMax) {

            // push the completed column array onto the master table array
            colArr.sort();
            tableArr.push(colArr);

            // reset column array and counter for next set of elements
            colArr = [];
            counter = 0;
        }
    }

    // push last column onto table
    tableArr.push(colArr);

    return tableArr;
}
BrandPage.propTypes = {
    //brands: PropTypes.array.isRequired
};
function mapStateToProps(state, ownProps) {
    return {
        brands: state.brands
    };
}
export default connect(mapStateToProps)(BrandPage);  